import apiClient from "@/services/ApiClientService";
import { SurchargeEvent } from "../models/SurchargeEvent";
import { dataLoading, dataLoadingWithResponse400Return } from "../decorators/LoadingAction.decorator";

export class RunSurchargeIncreaseApi {
  @dataLoading(undefined)
  static async tryListSurchargeEvents() {
    var result = await apiClient.get("/api/surcharge/listSurchargeEvents");
    if (result.status === 200) {
      return result.data as SurchargeEvent[];
    } else {
      return undefined;
    }
  }

  @dataLoadingWithResponse400Return
  static async tryGetCalculateSurcharge(selectedEventID: string, updateDay: string, surchargeType: string, productType: string[], bypassArgument: string) {
    return await apiClient.get(
      "/api/surcharge/calculate?surchargeEventId=" +
        selectedEventID +
        "&updateDay=" +
        updateDay +
        "&surchargeType=" +
        surchargeType +
        "&productLine=" +
        productType.toString() +
        bypassArgument
    );
  }
}
